import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ijsxdglhkmureqiyjlnc.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlqc3hkZ2xoa211cmVxaXlqbG5jIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYxMTc4NTYsImV4cCI6MjA5MTY5Mzg1Nn0.DgCb1FSnflUr9NLpY3oYMuAVEmBYGfQ6THgymFkVhqg';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
